import { useContext } from 'react';
import { PlatformThemeContext } from '@/components/providers/PlatformThemeProvider';

export function usePlatformTheme() {
  const context = useContext(PlatformThemeContext);
  if (!context)
    throw new Error('usePlatformTheme requires PlatformThemeProvider');
  return context;
}
